<template>
  <div class="flex max-w-sm">
    <div
      class="unit text-xs rounded-3xl text-center"
      :class="{ active: isUsingMetric }"
      @click="useMetricSystem"
    >
      {{ $t(onlyLength ? 'settingUserData.cm' : 'settingUserData.metric') }}
    </div>
    <div
      class="unit text-xs rounded-3xl text-center"
      :class="{ active: !isUsingMetric }"
      @click="useImperialSystem"
    >
      {{ $t(onlyLength ? 'settingUserData.inch' : 'settingUserData.imperial') }}
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'SystemSelector',
  props: {
    onlyLength: Boolean,
  },
  methods: {
    ...mapActions('app', ['useMetricSystem', 'useImperialSystem']),
  },
  computed: {
    ...mapGetters('app', ['isUsingMetric']),
  },
};
</script>

<style lang="scss" scoped>
.unit {
  @apply px-4;
  height: 28px;
  line-height: 28px;
  color: #b0b0b0;
}

.active {
  color: #fff;
  background: #1E1E1E;
}
</style>
